export default __webpack_public_path__ + "static/media/calendar-light.61247b6d.svg";